import Filter from './Filter'

export default class UserFilter extends Filter {
	constructor (filters) {
		super(filters)

		return this.get('page', null, '?page')
			.get('searchKeyword', null, '&keyword')
			.get('status', null, '&status')
			.get('sort', null, '&sort_by', this.filterSort)
			.get('itemsPerPage', null, '&paginate')
			.init()
	}

	filterSort ({ filter, value }) {
		filter.apiQuery += `&sort_by=${value.toLowerCase()}`
		filter.routerQuery.sort_by = value

		return filter
	}
}
